import React, { useEffect,  useState,useRef } from "react";
import { useForm } from "react-hook-form";
import { ScrollContainer } from "react-indiana-drag-scroll";
import { format, set } from "date-fns";
import YearCalendar from "../../shared/YearlyCalendar";
import { SlIcon, SlInput, SlOption, SlSelect,SlDrawer } from "@shoelace-style/shoelace/dist/react";
import API from "../../services/api";
import { useSelector } from "react-redux";
import NoDataFound from "../../shared/NoDataFound";
import { Toast } from "../../shared/Toast";
import * as XLSX from "xlsx";
import config from "../../config";
import { debounce } from "../../utils/Debounce";
import { getBrandOptions, toLakhs } from "../../utils/constants";
import TableSkelton from "../../shared/TableSkelton";
import filterSvg from "../../assets/images/filter.svg";


function NationalPlanning() {
  const selectedYear = useSelector((state) => state.Head.selectedYear);
  const [fileLoader, setFileLoader] = useState(0);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState("");
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [selectedType, setSelectedType] = useState('1')
  const fullyear = new Date(selectedYear).getFullYear();
  const [catABC, setCatABC] = useState('0');
  const [category, setCategory] = useState('0');
  const [categories, setCategories] = useState([]);
  const [sales, setSales] = useState([]);
  const [salesperson, setSalesPerson] = useState('0');
  const year = fullyear % 100;
  const { register, setValue } = useForm();
  const [showFilter, setShowFilter] = useState(false);
  const observer = useRef(null);
  const lastItemRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [userType, setUserType] = useState(-1);
  const searchBrand = (e) => {
    setSearch(e.target.value);
    setData([])
    setCurrentPage(0);
  };
  const fileChange = async (e) => {
    try {
      console.log(e.target.files)
       setFileLoader(1);
      const file = e.target.files[0]; // Get the uploaded file
      console.log(file)
      if (file) {
        const reader = new FileReader();
        reader.onload = async (evt) => {
          const arrayBuffer = evt.target.result; // ArrayBuffer result
          const workbook = XLSX.read(arrayBuffer, { type: "array" });

          // Assuming you want the first sheet
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];

          // Convert sheet to JSON, keeping raw data
          const rawData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          // Flatten the first two rows as headers
          const mainHeaders = rawData[0] || []; // First row
          const subHeaders = rawData[1] || []; // Second row

          // Fill undefined or blank header cells with placeholders
          const filledMainHeaders = mainHeaders.map(
            (header, i) => header || `Column ${i + 1}`
          );
          const flattenedHeaders = [];
          filledMainHeaders.forEach((main, index) => {
            const sub = subHeaders[index] || "";
            const sub1 = subHeaders[index + 1] || "";
            const sub2 = subHeaders[index +2] || "";
            const sub3 = subHeaders[index + 3] || "";
            if (sub) {
              flattenedHeaders.push(`${main} ${sub}`.trim());
              flattenedHeaders.push(`${main} ${sub1}`.trim());
              flattenedHeaders.push(`${main} ${sub2}`.trim())
              flattenedHeaders.push(`${main} ${sub3}`.trim())
            } else {
              flattenedHeaders.push(`${main}`.trim());
            }
          });

          // Extract the remaining rows as data
          const tableData = rawData
          .slice(2) // Exclude first two rows (headers)
          .filter(row => row.some(cell => cell !== undefined && cell !== null && cell !== "")); // Remove empty rows
          // Set state
          const dataObjects = tableData.map((row) => {
            const obj = {};
            flattenedHeaders.forEach((header, index) => {
              obj[header] = row[index] !== undefined ? row[index] : null; // Handle missing values
            });
            return obj;
          });
          setFileLoader(1)
          // Set state or use the objects
          let res = await API({
            url: `/planning/addData`,
            method: "POST",
            responseType: "json",
            data: {
              data: dataObjects,
              year: selectedYear,
            },
          });
          if (res.code === 200) {
            Toast("success", "Data Added Successfully");
            setCurrentPage(0);
            setSearch("")
            setFileLoader(0)
            loadData("", 0);
          }
          else{
            Toast('error',res?.message || "Something went wrong")
            setFileLoader(0)
          }
        };

        reader.readAsArrayBuffer(file); // Read file as ArrayBuffer
      }
    } catch (error) {
      console.error(error);
    } finally {
      setFileLoader(0);
      setValue("file_csv", "");
    }
  };
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const loadData = async (search, page,initiator='inifnite') => {
    if(currentPage > totalPages){
      return
    }
    if(data.length > 0 && initiator === 'inifnite'){
      setLoading(true);
    }
    else{
      setLoader(true);
    }
    try {
      let res = await API({
        url: `/planning/getData`,
        method: "POST",
        responseType: "json",
        data: {
          brandNameSearch: search,
          page,
          limit: config.PER_PAGE*2,
          year: fullyear,
          team:selectedType,
          catABC:catABC,
          category:category.replace(/_/g, ' '), // In shoelace select option space was replaced with _ , so replacing it with space
          sales_person_id:salesperson
        },
      });
      if (res.code === 200) {
        setUserType(res.data[0]?.userType)
        if(initiator === 'inifnite'){
          setData([...data, ...res.data[0]?.paginatedRecords]);
        }
        else{
          setData(res.data[0]?.paginatedRecords);
        }
        if(res.data[0]?.userType !== -1){
          setSelectedType(`${res.data[0]?.userType}`)
        }
        setTotalPages(
          Math.ceil(res.data[0]?.totalCount[0]?.count / (config.PER_PAGE*2))
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
      setLoading(false);
    }
  };
  const getdownloadData = async () => {
    setDownloadLoader(true);
    try {
      let res = await API({
        url: `/planning/downloadPlanning`,
        method: "POST",
        responseType: "json",
        data: {
          year: fullyear,
          brandNameSearch: search,
          team: selectedType
        },
      });
  
      if (res.code === 200) {
        const data = res.data;
        const workbook = XLSX.utils.book_new();
        const sheetData = [];
  
        // Create the first header row
        const mainHeader = [
          "Category",
          "VH",
          "STM",
          "Client",
          "Mapped/Unmapped",
          `Eenadu'${year - 2}`,
          `Sakshi'${year - 2}`,
          `W2N'${year - 2}`,
          `Eenadu'${year - 1}`,
          `Sakshi'${year - 1}`,
          `W2N'${year - 1}`,
          `Eenadu'${year}`,         // Add current year for Eenadu
          `Sakshi'${year}`,         // Add current year for Sakshi
          `W2N'${year}`,            // Add current year for Way2news
          "Cat ABC",
          `Projection ${year}`,
          `Stretch ${year}`,
          `Chase ${year}`,
          ...Array.from({ length: 12 }).flatMap((_, index) => {
            const date = new Date(fullyear, index, 1);
            return [`${format(date,'MMM')}'${year}`, null,null,null];
          }),
          "New/Existing",
        ];
  
        // Create the second header row
        const subHeader = [
          ...Array(18).fill(null), // Fill null for first 18 non-month columns
          ...Array.from({ length: 12 }).flatMap(() => ["Exp Insertions","Act Insertions", "Exp Revenue","Act Revenue"]),
          null, // Fill null for "New/Existing"
        ];
  
        // Push headers to sheetData
        sheetData.push(mainHeader);
        sheetData.push(subHeader);
        // Add data rows
        for (const item of data) {
          let rowData = [
            item.category,
            item.vertical_head,
            item.sales_person,
            item.brand_name,
            item.mapped === 1 ? "Mapped" : "UnMapped",
            item[`Eenadu_${fullyear - 2}`],
            item[`Sakshi_${fullyear - 2}`],
            item[`Way2news_${fullyear - 2}`],
            item[`Eenadu_${fullyear - 1}`],
            item[`Sakshi_${fullyear - 1}`],
            item[`Way2news_${fullyear - 1}`],
            item[`Eenadu_${fullyear}`], // Add current year data for Eenadu
            item[`Sakshi_${fullyear}`], // Add current year data for Sakshi
            item[`Way2news_${fullyear}`],
            item.catABC,
            item.planned_projection,
            item.planned_stretch,
            item.planned_chase,
          ];
  
          // Add monthly data dynamically
          for (let month = 1; month <= 12; month++) {
            rowData.push(
              getPlannedData(item.month_wise_data, month, "planned_insertions"),
              getPlannedData(item.month_wise_data, month, "insertions"),
              getPlannedData(item.month_wise_data, month, "planned_revenue"),
              getPlannedData(item.month_wise_data, month, "revenue")
            );
          }
  
          // Add final column for Existing/New
          rowData.push(item.existing === 1 ? "Existing" : "New");
  
          // Push the row to sheetData
          sheetData.push(rowData);
        }
  
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
  
        // Define merges for multi-row headers
        worksheet["!merges"] = [
          // Merge for static columns (0-17)
          { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, // Category
          { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }, // VH
          { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } }, // STM
          { s: { r: 0, c: 3 }, e: { r: 1, c: 3 } }, // Client
          { s: { r: 0, c: 4 }, e: { r: 1, c: 4 } }, // Mapped/Unmapped
          { s: { r: 0, c: 5 }, e: { r: 1, c: 5 } }, // Eenadu'22
          { s: { r: 0, c: 6 }, e: { r: 1, c: 6 } }, // Sakshi'22
          { s: { r: 0, c: 7 }, e: { r: 1, c: 7 } }, // W2N'22
          { s: { r: 0, c: 8 }, e: { r: 1, c: 8 } }, // Eenadu'23
          { s: { r: 0, c: 9 }, e: { r: 1, c: 9 } }, // Sakshi'23
          { s: { r: 0, c: 10 }, e: { r: 1, c: 10 } }, // W2N'23
          { s: { r: 0, c: 11 }, e: { r: 1, c: 11 } }, // Eenadu'24
          { s: { r: 0, c: 12 }, e: { r: 1, c: 12 } }, // Sakshi'24
          { s: { r: 0, c: 13 }, e: { r: 1, c: 13 } }, // W2N'24
          { s: { r: 0, c: 14 }, e: { r: 1, c: 14 } }, // Cat ABC
          { s: { r: 0, c: 15 }, e: { r: 1, c: 15 } }, // Projection
          { s: { r: 0, c: 16 }, e: { r: 1, c: 16 } }, // Stretch
          { s: { r: 0, c: 17 }, e: { r: 1, c: 17 } }, // Chase
          // Merge for months (18-41)
          ...Array.from({ length: 12 }).map((_, index) => ({
            s: { r: 0, c: 18 + index * 4 }, // Start of the month merge
            e: { r: 0, c: 21 + index * 4 }, // End of the month merge
          })),
          { s: { r: 0, c: 66 }, e: { r: 1, c: 66 } }, // New/Existing
        ];
  
        // Append worksheet to workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
        // Export the file
        XLSX.writeFile(workbook, `Planning_${selectedType == 1 ? 'National' : selectedType == 2 ? 'Local' : selectedType == 3 ? 'Metro' : 'Local-TN'}_${fullyear}.xlsx`);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setDownloadLoader(false);
    }
  };
  

  const getcategories = async () => {
    try {
      let res = await API({
        url:"/plansummary/categories",
        method:'POST',
        responseType:'json',
        data:{}
      })
      if(res.code === 200){
        setCategories(res.data)
      }
    } catch (error) {
      console.error(error);
    }
  }
  const getSales = async () => {
    try {
      let res = await API({
        url:"/planning/getSales",
        method:'POST',
        responseType:'json',
        data:{
          type:selectedType
        }
      })
      if(res.code === 200){
        setSales(res.data)
      }
    } catch (error) {
      console.error(error);
    }
  }

  function getPlannedData(data, month, type) {
    // Validate type

    // Find the record for the specified month
    const record = data.find((item) => item.month === month);

    // Return the value based on the type or 0 if no record is found
    if (record) {
      if(type === "planned_insertions"){
        return record?.planned_insertions || 0
      }
      else if(type === 'planned_revenue'){
        return record?.planned_revenue || 0
      }
      else if (type === "insertions") {
        return record[`Way2news_insertions_${fullyear}`] !== undefined 
          ? record[`Way2news_insertions_${fullyear}`] 
          : 0;
      } else {
        return record[`Way2news_revenue_${fullyear}`] !== undefined 
          ? record[`Way2news_revenue_${fullyear}`] 
          : 0;
      }
    } else {
      return 0; // Default value if no matching month is found
    }
  }

  useEffect(()=>{
    getcategories()
  },[])

  useEffect(()=>{
    getSales()
    setSalesPerson('0')
  },[selectedType])

  useEffect(() => {
      loadData(search, 0,'main');
      setCurrentPage(0);
  }, [selectedYear, search, selectedType,catABC, category, salesperson]);

  useEffect(() => {
    if (observer.current) observer.current.disconnect(); // Disconnect previous observer

    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && !loading) {
        loadData(search, currentPage + 1);
      setCurrentPage(currentPage + 1);
      }
    });

    if (lastItemRef.current) observer.current.observe(lastItemRef.current);

    return () => {
      if (observer.current) observer.current.disconnect(); // Clean up on unmount
    };
  }, [data, loading]);


  return (
    <>
      <div className="d-flex justify-end items-center my-2">
        <div className="mobHide">
      <div className="d-flex justify-end items-end  gap-3">
        <SlSelect size="small" value={selectedType} label="Team" onSlChange={(e) => {setSelectedType(e.target.value); setCurrentPage(0);setData([])}}>
          {getBrandOptions(userType, localStorage.getItem('email'))?.map((type) => (
            <SlOption key={type.value} value={type.value}>{type.label}</SlOption>
          ))}
        </SlSelect>
        <SlSelect label="cat ABC" size="small" value={catABC} onSlChange={(e) => {setCatABC(e.target.value); setCurrentPage(0);setData([])}}>
          <SlOption key="All" value="0">All</SlOption>
          <SlOption key="A" value="A">A</SlOption>
          <SlOption key="B" value="B">B</SlOption>
          <SlOption key="C" value="C">C</SlOption>
          </SlSelect>
        <SlSelect label="Category" size="small" value={category} onSlChange={(e) => {setCategory(e.target.value); setCurrentPage(0);setData([])}}>
        <SlOption key="All" value="0">All</SlOption>
          {categories.map((category) => (
            <SlOption key={category.category_name} value={category.category_name.replace(/ /g, '_')}>{category.category_name}</SlOption>
          ))}
        </SlSelect>
        <SlSelect label="Sales" size="small" value={salesperson} onSlChange={(e) => {setSalesPerson(e.target.value); setCurrentPage(0);setData([])}}>
        <SlOption key="All" value="0">All</SlOption>
          {sales.map((sales_person) => (
            <SlOption key={sales_person.sales_person_id} value={sales_person.sales_person_id}>{sales_person.name}</SlOption>
          ))}
        </SlSelect>
        <SlInput
          type="text"
          size="small"
          label="Search Brand"
          placeholder="Search"
          value={search}
          onSlInput={debounce(searchBrand, 500)}
        />
        <YearCalendar startYear={2023} endYear={2100}></YearCalendar>
         </div>
         </div>
        <img src={filterSvg} alt="filter" className="cursor-pointer inline md:hidden" onClick={()=>{setShowFilter(true)}} />
        {fileLoader ? (
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        ) : (
          <label htmlFor="file" className="m-0">
            <i
              className="bi bi-arrow-up-circle ml-3 px-2 py-1 rounded-lg  bg-slate-100 hover:text-cyan-500 cursor-pointer hover:bg-slate-150"
              data-toggle="tooltip"
              title="Upload Planning Sheet"
            ></i>
            <input
              type="file"
              id="file"
              style={{ display: "none" }}
              name="file"
              {...register("file_csv", {
                required: false,
                onChange: (e) => fileChange(e),
              })}
            />
          </label>
        )}
        {downloadLoader ? (
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        ) : (
          <div
            className="w-7 h-7 bg-slate-100 hover:text-cyan-500 rounded-lg cursor-pointer items-center justify-center hover:bg-slate-150 flex"
            onClick={getdownloadData}
          >
            <sl-tooltip content="Download" placement="top">
              <SlIcon library="lucide" name="download" />
            </sl-tooltip>
          </div>
        )}
      </div>
      <ScrollContainer>
        <table className="table table-bordered">
          <thead className="">
            <tr>
              <th className="!bg-sky-300" rowSpan={2}>
                Category
              </th>
              <th className="!bg-sky-300" rowSpan={2}>
                VH
              </th>
              <th className="!bg-sky-300" rowSpan={2}>
                STM
              </th>
              <th className="!bg-sky-300" rowSpan={2}>
                Client
              </th>
              <th className="!bg-sky-300" rowSpan={2}>
                Mapped/Unmapped
              </th>
              <th className="!bg-sky-300" rowSpan={2}>
                Eenadu'{year - 2}
              </th>
              <th className="!bg-sky-300" rowSpan={2}>
                Sakshi'{year - 2}
              </th>
              <th className="!bg-sky-300" rowSpan={2}>
                W2N'{year - 2}
              </th>
              <th className="!bg-sky-300" rowSpan={2}>
                Eenadu'{year - 1}
              </th>
              <th className="!bg-sky-300" rowSpan={2}>
                Sakshi'{year - 1}
              </th>
              <th className="!bg-sky-300" rowSpan={2}>
                W2N'{year - 1}
              </th>
              <th className="!bg-sky-300" rowSpan={2}>
                Eenadu'{year}
              </th>
              <th className="!bg-sky-300" rowSpan={2}>
                Sakshi'{year}
              </th>
              <th className="!bg-sky-300" rowSpan={2}>
                W2N'{year}
              </th>
              <th className="!bg-green-300" rowSpan={2}>
                Cat ABC
              </th>
              <th className="!bg-yellow-200" rowSpan={2}>
                Projection {year}
              </th>
              <th className="!bg-orange-200" rowSpan={2}>
                Strech {year}
              </th>
              <th className="!bg-red-200" rowSpan={2}>
                Chase {year}
              </th>
              {Array.from({ length: 12 }).map((_, index) => {
                const date = new Date(2024, index, 1);
                return (
                  <>
                    <th className="!bg-yellow-50" colSpan={4} key={index}>
                      {format(date, "MMM")}'{year}
                    </th>
                  </>
                );
              })}
              <th className="!bg-yellow-50" rowSpan={2}>
                New / Existing
              </th>
            </tr>
            <tr className="!bg-yellow-50">
              {Array.from({ length: 12 }).map((_, index) => {
                return (
                  <>
                    <th colSpan={1} key={index}>
                      Exp Insertions
                    </th>
                    <th>Act Insertions</th>
                    <th colSpan={1} key={index}>
                      Exp Revenue
                    </th>
                    <th>Act Revenue</th>
                  </>
                );
              })}
            </tr>
          </thead>
          {!loader && data?.length > 0 ? (
            <tbody>
              {data.map((item,index) => (
                <tr key={`${index}`} ref={data.length - 2 === index ? lastItemRef : null}>
                  <td>{item.category}</td>
                  <td>{item.vertical_head}</td>
                  <td>{item.sales_person}</td>
                  <td>{item.brand_name}</td>
                  <td>{item.mapped === 1 ? "Mapped" : "UnMapped"}</td>
                  <td>{toLakhs(item[`Eenadu_${fullyear - 2}`])}</td>
                  <td>{toLakhs(item[`Sakshi_${fullyear - 2}`])}</td>
                  <td>{toLakhs(item[`Way2news_${fullyear - 2}`])}</td>
                  <td>{toLakhs(item[`Eenadu_${fullyear - 1}`])}</td>
                  <td>{toLakhs(item[`Sakshi_${fullyear - 1}`])}</td>
                  <td>{toLakhs(item[`Way2news_${fullyear - 1}`])}</td>
                  <td>{toLakhs(item[`Eenadu_${fullyear}`])}</td>
                  <td>{toLakhs(item[`Sakshi_${fullyear}`])}</td>
                  <td>{toLakhs(item[`Way2news_${fullyear}`])}</td>
                  <td>{item.catABC}</td>
                  <td>{item.planned_projection}</td>
                  <td>{item.planned_stretch}</td>
                  <td>{item.planned_chase}</td>
                  {Array.from({ length: 12 }).map((_, index) => {
                    return (
                      <>
                        <td colSpan={1} key={index}>
                          {getPlannedData(
                            item.month_wise_data,
                            index + 1,
                            "planned_insertions"
                          )}
                        </td>
                        <td>{getPlannedData(
                            item.month_wise_data,
                            index + 1,
                            "insertions"
                          )}</td>
                        <td colSpan={1} key={index}>
                          {getPlannedData(
                            item.month_wise_data,
                            index + 1,
                            "planned_revenue"
                          )}
                        </td>
                        <td>{getPlannedData(
                            item.month_wise_data,
                            index + 1,
                            "revenue"
                          )}</td>
                      </>
                    );
                  })}
                  <td>
                    {(item.existing != null || item.existing !== undefined)
                      ? item.existing === 1
                        ? "EXisting"
                        : "New"
                      : ""}
                  </td>
                </tr>
              ))}
            </tbody>
          ) : loader ? (
            <TableSkelton colspan={40} />
          ) : (
            <NoDataFound colspan={40} />
          )}
        </table>
      </ScrollContainer>
        {loading && (
          <div className="flex justify-center items-center">
            <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-700"></div>
          </div>
        )}
      <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={() => { }}
      style={{ "--size": "fit-content" }}
      >
        <div className="relative">
          <h3 className="mb-3">Apply Filters</h3>
          <hr></hr>
          <div className="d-flex gap-3 justify-center items-center flex-col">
        <SlSelect size="small" value={selectedType}  label="Team" onSlChange={(e) => {setSelectedType(e.target.value); setCurrentPage(0)}}>
        {getBrandOptions(userType, localStorage.getItem('email'))?.map((type) => (
            <SlOption key={type.value} value={type.value}>{type.label}</SlOption>
          ))}
        </SlSelect>
        <SlSelect label="cat ABC" size="small" value={catABC} onSlChange={(e) => {setCatABC(e.target.value); setCurrentPage(0)}}>
          <SlOption key="All" value="0">All</SlOption>
          <SlOption key="A" value="A">A</SlOption>
          <SlOption key="B" value="B">B</SlOption>
          <SlOption key="C" value="C">C</SlOption>
          </SlSelect>
        <SlSelect label="Category" size="small" value={category} onSlChange={(e) => {setCategory(e.target.value); setCurrentPage(0)}}>
        <SlOption key="All" value="0">All</SlOption>
          {categories.map((category) => (
            <SlOption key={category.category_name} value={category.category_name.replace(/ /g, '_')}>{category.category_name}</SlOption>
          ))}
        </SlSelect>
        <SlSelect label="Sales" size="small" value={salesperson} onSlChange={(e) => {setSalesPerson(e.target.value); setCurrentPage(0)}}>
        <SlOption key="All" value="0">All</SlOption>
          {sales.map((sales_person) => (
            <SlOption key={sales_person.sales_person_id} value={sales_person.sales_person_id}>{sales_person.name}</SlOption>
          ))}
        </SlSelect>
        <SlInput
          type="text"
          size="small"
          label="Search Brand"
          placeholder="Search"
          value={search}
          onSlInput={debounce(searchBrand, 500)}
        />
        <YearCalendar startYear={2023} endYear={2100}></YearCalendar>
         </div>
          <SlIcon
            className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => setShowFilter(false)}
          ></SlIcon>
        </div>
      </SlDrawer>
    </>
  );
}

export default NationalPlanning;